import createNavigation from "components/masthead/helpers/create_navigation";
import "./component.scss";

const { initMobileNavigation } = createNavigation({
  containerSelector: ".js-masthead-drinkware-navigation",
  navigationLinkSelector: null,
  navigationContentSelector: null,
  activeLinkClassName: null,
  slideSelector: ".js-masthead-drinkware-slide",
  slideLinkSelector: ".js-masthead-drinkware-slide-link",
  expandedSlideClassName: "masthead-drinkware-navigation__slide--expanded",
  backSelector: '.js-mobile-submenu-trigger[data-category="Drinkware"]',
  mouseleaveCategory: null,
  mobileBackMode: "reset-all",
  hasDesktopNav: false
});

export default initMobileNavigation;
